var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.114502C5.17727 0.11657 3.42979 0.841562 2.14092 2.13043C0.85206 3.41929 0.127068 5.16677 0.125 6.9895C0.125 12.8723 6.375 17.3153 6.64141 17.5012C6.74649 17.5748 6.87169 17.6143 7 17.6143C7.12831 17.6143 7.25351 17.5748 7.35859 17.5012C7.625 17.3153 13.875 12.8723 13.875 6.9895C13.8729 5.16677 13.1479 3.41929 11.8591 2.13043C10.5702 0.841562 8.82273 0.11657 7 0.114502ZM7 4.4895C7.49445 4.4895 7.9778 4.63612 8.38893 4.91083C8.80005 5.18553 9.12048 5.57598 9.3097 6.03279C9.49892 6.48961 9.54843 6.99228 9.45196 7.47723C9.3555 7.96218 9.1174 8.40764 8.76777 8.75727C8.41814 9.1069 7.97268 9.345 7.48773 9.44147C7.00277 9.53793 6.50011 9.48842 6.04329 9.2992C5.58648 9.10998 5.19603 8.78955 4.92133 8.37843C4.64662 7.9673 4.5 7.48396 4.5 6.9895C4.5 6.32646 4.76339 5.69058 5.23223 5.22174C5.70107 4.75289 6.33696 4.4895 7 4.4895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.4a4430ecd1fa189e2c0d23d97f5d6932.svg";
export { ForwardRef as ReactComponent };